import React from "react";
import { partnerIconByKey } from "./partnerIcons";
import "../Home.css";

export default function PartnerSection({ t }) {
  return (
    <>
      <div className="section-wave" aria-hidden="true" />
    <section className="partner-section container scroll-animate from-bottom" id="partner-benefits" aria-labelledby="partner-title">
        <h2 id="partner-title" className="home-section-title partner-title-center scroll-animate from-bottom delay-1">
          {t.partnerTitle}
        </h2>
        <p className="partner-intro scroll-animate from-bottom delay-2">{t.partnerIntro}</p>

        {t.partnerTrust?.length > 0 && (
          <ul className="partner-trust-bar scroll-animate from-bottom delay-2" aria-label="Trust highlights">
            {t.partnerTrust.map((item) => (
              <li key={item} className="partner-trust-item">
                {item}
              </li>
            ))}
          </ul>
        )}

        <div className="partner-grid">
          {t.partner.map((item, index) => {
            const Icon = partnerIconByKey[item.key];
            return (
              <article
                key={item.key}
                className={`partner-card partner-card-delay-${index + 1}`}
                tabIndex={0}
              >
                {item.metric && <span className="partner-metric">{item.metric}</span>}
                <div className="partner-icon">
                  <Icon />
                </div>
                <h3 className="partner-card-title">{item.title}</h3>
                <p className="partner-card-desc">{item.desc}</p>
              </article>
            );
          })}
        </div>
      </section>
      <div className="section-wave" aria-hidden="true" />
    </>
  );
}
